import React from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

export const Slide = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={500}	classNames="slide-left">
		{children}
	</CSSTransition>
)

export const Fade = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={500} classNames="fade">
		{children}
	</CSSTransition>
)

export const FadeAbsolute = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={500}	classNames="absolute fade">
		{children}
	</CSSTransition>
)

export const FadeAbsolutePage = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={{enter: 600, exit: 400}} classNames="fade-page" unmountOnExit={true}>
		{children}
	</CSSTransition>
)

export const FadeAbsoluteLoader = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={200}	classNames="fade-loader">
		{children}
	</CSSTransition>
)

export const FadeAbsolute2 = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={300}	classNames="fade-absolute">
		{children}
	</CSSTransition>
)

export const SlideRight = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={500}	classNames="slide-right">
		{children}
	</CSSTransition>
)

export const SlideFromRight = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={450}	classNames="slide-from-right">
		{children}
	</CSSTransition>
)

export const SlideUp = ({ children, ...props }) => (
	<CSSTransition {...props} timeout={450}	classNames="slide-up">
		{children}
	</CSSTransition>
)


// WEBPACK FOOTER //
// ./src/components/Transitions.js